module.exports = __webpack_public_path__ + "img/1.ff62877b.png";